var map = {
	"./vip_icon_adultcrush.svg": "./assets/vipIcons/vip_icon_adultcrush.svg",
	"./vip_icon_close.svg": "./assets/vipIcons/vip_icon_close.svg",
	"./vip_icon_discreetcrush.svg": "./assets/vipIcons/vip_icon_discreetcrush.svg",
	"./vip_icon_foxytemptation.svg": "./assets/vipIcons/vip_icon_foxytemptation.svg",
	"./vip_icon_localhussies.svg": "./assets/vipIcons/vip_icon_localhussies.svg",
	"./vip_icon_meetwives.svg": "./assets/vipIcons/vip_icon_meetwives.svg",
	"./vip_icon_megaflirt.svg": "./assets/vipIcons/vip_icon_megaflirt.svg",
	"./vip_icon_steamymatches.svg": "./assets/vipIcons/vip_icon_steamymatches.svg",
	"./vip_icon_steamyplay.svg": "./assets/vipIcons/vip_icon_steamyplay.svg",
	"./vip_icon_truebootycall.svg": "./assets/vipIcons/vip_icon_truebootycall.svg",
	"./vip_icon_wivesnow.svg": "./assets/vipIcons/vip_icon_wivesnow.svg",
	"./vip_icon_xmeeting.svg": "./assets/vipIcons/vip_icon_xmeeting.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./assets/vipIcons sync recursive ^\\.\\/vip_icon_.*\\.svg$";